// extracted by mini-css-extract-plugin
export var errorsContainer = "_t6-1";
export var link = "_t6-0";